import {Injectable} from '@angular/core';
import {Property} from "./property/property.model";
import {PropertyType} from "./property/property-type.enum";
import {ConfigStructure} from "../config/config-structure.model";
import {DescriptorLink} from "./property/descriptor-link.model";

class Match {

  anyMatch = false;

}

@Injectable({
  providedIn: 'root'
})
export class TranslatorService {

  private regexp = '\\${([^}]+)\\}';

  constructor() {
  }

  public translate(config: ConfigStructure, properties: Property[], returnRaw: boolean): any {
    if (!properties || properties.length === 0) {
      return '';
    }
    let template = config.template;
    let match = new Match();
    let regExp = new RegExp(this.regexp, "g");
    if (config.nestedConfig.length > 0) {
      let hit;
      while ((hit = regExp.exec(config.template)) !== null) {
        template = this.translateMulti(properties, hit, config, template, match);
      }
    } else {
      if(returnRaw) {
        return this.translateSingle(config, properties, match, returnRaw);
      } else {
        template = this.translateSingle(config, properties, match, false);
      }

    }
    if (config.allMatches) {
      if (config.elseConfig && regExp.exec(template) !== null) {
        return this.translate(config.elseConfig, properties, false);
      } else {
        return regExp.exec(template) === null ? template : ''
      }
    } else {
      if (match.anyMatch){
        let result = template.replace(regExp, '');
        if(/[A-Za-z0-9]/.test(result)){
          return result;
        } else {
          return '';
        }
      } else {
        return '';
      }
    }
  }

  public find(properties: Property[], key: string): Property {
    let keys = key.replace("${", "").replace("}", "").split(".");
    let element: Property = null;
    let propList = properties;
    keys.forEach(value => {
      if (element !== null) {
        propList = <Property[]>element.value;
      }
      element = this.getProperty(propList, value);
    });

    return element;
  }

  private translateMulti(properties: Property[], hit, config: ConfigStructure, template, match: Match) {
    let property = this.find(properties, hit[0]);
    let configStructure = this.findConfig(config, property);
    if (configStructure && property.value instanceof Array) {
      let value = <Property[]>property.value;
      let output = '';
      value.slice(0, config.limitNestedIteration).forEach((props) => {
        let translateSingle = this.translateSingle(configStructure, props, match , false);
        output = output.concat(translateSingle + (/\S/.test(translateSingle) ? ", " : ""));
      });
      template = template.replace(hit[0], output.slice(0, output.length - 2));
    } else if (configStructure) {
      template.replace(hit[0], this.translateSingle(configStructure, properties, match, false));
    } else {
      template = this.translateSingle(config, properties, match, false);
    }
    return template;
  }

  private translateSingle(config: ConfigStructure, properties: Property[] | any, match: Match , returnRaw: boolean): any {
    let hit;
    let regExp = new RegExp(this.regexp, "g");
    let map = new Map<string, string>();
    let template = config.template;
    while ((hit = regExp.exec(template)) !== null) {
      let property = this.find(properties, hit[0]);
      if (returnRaw) return property;
      let value1 = this.getValue(property);
      map.set(hit[0], value1 !== '' ? value1 + '' : hit[0]);
    }
    map.forEach((value, key) => {
      if (value !== '' && !match.anyMatch) {
        match.anyMatch = true;
      }
      template = template.replace(key, value);
    });
    return template;
  }

  private findConfig(config: ConfigStructure, property): ConfigStructure {
    let temporaryConfig: ConfigStructure = null;
    if (!property || !config) {
      return temporaryConfig;
    }
    config.nestedConfig.forEach((config) => {
      if (config.name === property.name) {
        temporaryConfig = config;
      }
    });
    return temporaryConfig;
  }

  private getValue(property): string {
    let output = '';
    if (property === null) {
      return output;
    }
    if (property instanceof DescriptorLink) {
      return output;
    }
    output = this.getOutput(property);
    return output;
  }

  private getOutput(property) {
    let output = '';
    if (property.type === PropertyType.ARRAY) {
      // console.log(property);
      output = this.getValueFromArray(property);
    } else if (property.type === PropertyType.DESCRIPTOR) {
      return output;
    }
    else {
      output = property.value;
    }
    return output;
  }

  private getValueFromArray(property) {

    let output = '';
    if (property.value === output || !property.value) {
      return output;
    } else {
      property.value.forEach((element, index) => {
        if (typeof element === 'string' || typeof element === 'number' || typeof element === 'boolean') {
          output = output.concat(element + '');
        } else if (element instanceof Array) {
          element.forEach(value => {
            output = output.concat(this.getOutput(value) + " ");
          })
        }
        else {
          let keys = Object.keys(element);
          keys.forEach((key) => {
            output = output.concat(key + ": " + element[key]);
          })
        }
        output = output.concat(index === property.value.length ? '' : ", ");
      });
      return output.slice(0, output.length - 2);
    }
  }

  private getProperty(properties, key: string): Property {
    let property: Property = null;

    if (!properties || properties === '') {
      return property;
    }

    if (properties instanceof Property) {
      if (properties.name === key) {
        property = properties;
      }
      return property;
    }
    if (Array.isArray(properties)) {
      properties.forEach(value => {
        if (value instanceof Property) {
          if (value.name === key) {
            property = value;
            return;
          }
        } else if (value) {
          value.forEach((element) => {
            if (element.name === key) {
              property = element;
              return;
            }
          })
        }

      });
    }
    return property;
  }
}
